import { getDefaultDays } from 'selectors/availability/schedules'

export const getDateOverrides = ({ rules }) => rules.filter((rule) => rule.type === 'date')

export const getAvailabilityFromRule = (rule) => {
  if (!rule) {
    return {
      availableHours: [],
      dateOverrides: [],
    }
  }

  return {
    availableHours: getDefaultDays(rule.rules),
    dateOverrides: getDateOverrides(rule),
    timezone: rule.timezone,
  }
}
